import React from 'react';
import { TitleTextLarge } from 'Packages/FacetDesign/Components';
import { FDIcon, FDStack } from '@facet-wealth/design';
import PropTypes from 'prop-types';

export const DestinationAccount = ({ value }) => {
  return (
    <FDStack direction={'column'} justifyContent={'flex-start'} spacing={1} width={'50%'} maxWidth={'220px'} wrap>
      <FDIcon icon={'fac'} alignSelf={'center'} />
      <TitleTextLarge align={'center'} value={value} />
    </FDStack>
  );
};

DestinationAccount.propTypes = {
  value: PropTypes.string.isRequired,
};
